export { getCookie, setCookie, clearCookie };

function getCookie(name) {
    const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith(`${name}=`))
        ?.split(`${name}=`)[1];
    return cookieValue || null;
}


// function setCookie(name, cookieValue, path = '/') {
//     document.cookie = `${name}=${cookieValue}; path=${path}; secure; samesite=strict`;
// }

function setCookie(name, cookieValue, options = {}) {
    const { path = '/', domain, secure = true, samesite = 'Strict', expires } = options;
    let cookieString = `${name}=${cookieValue}; path=${path}`;
    if (domain) {
        cookieString += `; domain=${domain}`;
    }
    if (secure) {
        cookieString += '; secure';
    }
    if (samesite) {
        cookieString += `; samesite=${samesite}`;
    }
    if (expires) {
        cookieString += `; expires=${expires}`;
    }
    document.cookie = cookieString;
}

function clearCookie(name, path = '/') {
    document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}